import { createStore } from "vuex"
import { auth } from "./auth.module"

const store = createStore({
    modules: {
        auth,
    },
    state: {
        hiddenBody: false
    }
});

export default store